import { Link, useLocation } from "react-router-dom";
import logoIcon from "../assets/images/logo.png";
import SideBarDropdown from "./SideBarDropdown";
import { useContext, useEffect, useState } from "react";
// import { Context } from "../context/MainContext";

const Sidebar = ({ drawer, setModalIsOpen }) => {
  const { pathname } = useLocation();
  const [links, setLinks] = useState([
    { name: "Dashboard", url: "", iconClassName: "feather ft-home" },

    {
      name: "Blogs",
      url: "blogs",
      iconClassName: "ti-files",
    },
    {
      name: "Products",
      url: "products",
      iconClassName: "ti-package",
    },
    {
      name: "Orders",
      url: "orders",
      iconClassName: "ti-shopping-cart",
    },
    {
      name: "Training Application",
      url: "training",
      iconClassName: "ti-book",
    },
    // {
    //   name: "Interviews",
    //   url: "interviews",
    //   iconClassName: "ti-files",
    // },
    // {
    //   name: "Gallery",
    //   url: "gallery",
    //   iconClassName: "ti-image",
    // },
    {
      name: "Settings",
      url: "settings",
      iconClassName: "feather ft-settings",
    },
  ]);
  // const { user } = useContext(Context);

  return (
    <nav className={drawer ? "sidebar draw" : "sidebar"}>
      <div>
        <div className="sidebar__top">
          <img src={logoIcon} alt="" className="sidebar__top__logo" />
        </div>
        <ul className="sidebar__list">
          {links.map((link) => {
            return (
              <div key={link.name}>
                {!link.dropDown ? (
                  <Link
                    // key={link.name}
                    to={
                      link.url === "" ? "/dashboard" : "/dashboard/" + link.url
                    }
                    onClick={() => drawer && setModalIsOpen(false)}
                  >
                    <li
                      className={
                        pathname.includes(link.url) && link.name !== "Dashboard"
                          ? "sidebar__list__item active"
                          : pathname === "/dashboard" &&
                              link.name === "Dashboard"
                            ? "sidebar__list__item active"
                            : "sidebar__list__item"
                      }
                    >
                      <i className={link.iconClassName}></i>
                      {link.name}
                    </li>
                  </Link>
                ) : (
                  <SideBarDropdown
                    // key={link.name}
                    pathname={pathname}
                    setModalIsOpen={setModalIsOpen}
                    link={link}
                    drawer={drawer}
                  />
                )}
              </div>
            );
          })}
        </ul>
      </div>

      {/* <button className="btn sidebar__btn" onClick={handleLogout}>
        Logout
      </button> */}
    </nav>
  );
};

export default Sidebar;
